import React from 'react';

/**
 * AnimatedCounter — eases from 0 (or `from`) to `value` once on mount.
 * Pass plain numbers; for percentages render the suffix outside.
 */
export function AnimatedCounter({ value, from = 0, duration = 900, className = '' }) {
  const [shown, setShown] = React.useState(from);
  React.useEffect(() => {
    let raf;
    const start = performance.now();
    const target = Number(value) || 0;
    const begin = Number(from) || 0;
    const step = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      const v = begin + (target - begin) * eased;
      setShown(Number.isInteger(target) && Number.isInteger(begin)
        ? Math.round(v)
        : Math.round(v * 10) / 10);
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => raf && cancelAnimationFrame(raf);
  }, [value, from, duration]);
  return <span className={`nums ${className}`}>{shown}</span>;
}
export default AnimatedCounter;
